import * as React from 'react';

import { useQuery } from '@apollo/client';

import type {
  AcademicDisciplineNameQueryVariables,
  AcademicDisciplineSummariesResult,
} from 'bundles/enterprise-legacy-learner-home/components/single-program/SingleProgramGraphqlQueries';
import { AcademicDisciplineNameQuery } from 'bundles/enterprise-legacy-learner-home/components/single-program/SingleProgramGraphqlQueries';
import AcademicDisciplineContext from 'bundles/page-config-common/contexts/enterprise/AcademicDisciplineContext';
import { useEnterpriseProductFeatures } from 'bundles/unified-common/contexts/EnterpriseProductFeaturesContext';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

const AcademicDisciplineProvider = ({ children }: React.PropsWithChildren<{}>) => {
  const program = useProgram();
  const features = useEnterpriseProductFeatures();

  const { data, loading } = useQuery<AcademicDisciplineSummariesResult, AcademicDisciplineNameQueryVariables>(
    AcademicDisciplineNameQuery,
    {
      variables: {
        disciplineId: program?.metadata.linkedAcademicDisciplineIds?.[0] as string,
      },
      skip: !features?.enableAcademicDisciplines || !program?.metadata?.linkedAcademicDisciplineIds?.length,
      ssr: false,
      errorPolicy: 'all' as const,
      context: { clientName: 'gatewayGql' },
    }
  );

  if (!program || !features || loading) {
    return (
      <AcademicDisciplineContext.Provider
        value={{ academicDisciplineNameLoading: true, academicDisciplineName: undefined }}
      >
        {children}
      </AcademicDisciplineContext.Provider>
    );
  }

  const academicDisciplineName = data?.AcademicDiscipline?.queryAcademicDisciplineById.name;

  return (
    <AcademicDisciplineContext.Provider value={{ academicDisciplineNameLoading: false, academicDisciplineName }}>
      {children}
    </AcademicDisciplineContext.Provider>
  );
};

export default AcademicDisciplineProvider;
